<template>
  <div class="element-input element-checkbox">
    <template v-if="type === 'signature'">
      <!-- 보험 점검 배너 -->
      <div style="max-width:500px; margin:0 auto 2rem; padding:20px; background:#f7f7f7; border-radius:12px; text-align:center;">
        <p style="font-size:1.1em; font-weight:bold; color:#333; margin-bottom:15px;">가입된 보험, 제대로 보장받고 계신가요?</p>
        <div @click="$emit('check-insurance')" 
          style="cursor:pointer; position:relative; display:flex; align-items:center; justify-content:space-between; background:linear-gradient(to right, #4CAF50, #66BB6A); color:#fff; font-size:2rem; font-weight:bold; border-radius:8px;">
          <span style="display:flex; align-items:center; margin-left: 2rem"><i class="material-icons" style="margin-right:6px; font-size:40px; transform:scaleX(-1);">search</i>내 보험 무료 점검 신청하기</span>
          <i class="material-icons" style="position:absolute; right:5px; font-size:40px; -webkit-text-stroke:2px #5ab96a;">chevron_right</i>
        </div>
      </div>
      <div style="font-size: 1.2rem; color: #191F28; font-weight: 600;">아래에서 견적서를 받아보실 보험종목을 선택해주세요.</div>
      <div style="font-size: 0.8rem; color: #ADB5BD; margin-bottom: 30px;">(중복가능)</div>
    </template>

    <template v-else>
      <div class="label">{{ label }}</div>
    </template>

    <ul>
      <li
        :class="{
          on: isMultiple
          ? ( value.indexOf( item.value ) >= 0 )
          : value
        }"
        v-for="item in items"
        :key="item.value"
        @click="selectItem( item.value )"
      >
        <template v-if="type === 'signature' && item.label === '운전자보험'">
          <span class="event-tooltip">{{ item.label }}</span>
        </template>
        <template v-else>
          {{ item.label }}
        </template>
      </li>
    </ul>
    <div class="error" v-if="error">{{ error }}</div>
  </div>
</template>
<script>
export default {
  props: [ "value", "label", "error", "items", "type" ],
  computed: {
    isMultiple(){
      return this.items && this.items.length > 1;
    },
    model: {
      get(){
        return this.value;
      },
      set( value ){
        this.$emit( "input", value );
      }
    }
  },
  created(){
    this.$watch( "isMultiple", isMultiple => {
      if( isMultiple && !Array.isArray( this.value ) ){
        this.$emit( "input", []);
      };
    }, { immediate: true });
  },
  methods: {
    selectItem( value ){
      if( value === '없음' ){
        if( this.isMultiple ){
          if( this.value.indexOf( value ) >= 0 ){
            this.$emit( "input", this.value.filter( o => o != value ) );
          }else{
            var temp = [];
            temp = temp.concat( [ value ]);
            this.$emit( "input", temp );
          };
        }
      }
      else{
        if( this.isMultiple ){
          if( this.value.indexOf( value ) >= 0 ){
            this.$emit( "input", this.value.filter( o => o != value ) );
          }else{
            var temp = this.value;
            if(temp && temp[0] == '없음'){
              temp = [];
            }
            temp = temp.concat( [ value ] );

            this.$emit( "input", temp );
          };
        }else{
          if( this.value ){
            this.$emit( "input", false );
          }else{
            this.$emit( "input", true );
          };
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.event-tooltip {
	background-color: #fff;
	border-radius: 10px;
	position: relative;
	text-align: center;
  
  &::before {
    background-color: #F04452;
    content: ' ';
    display: block;
    position: absolute;
    width: 10px;
    height: 10px;
    z-index: 999;
    top: 0;
    left: -38%;
    transform: translate(-50%, calc(-100% - 7px)) rotate(45deg);
  }

  &::after {
    background-color: #F04452;
    border-radius: 10px;
    color: #fff;
    display: block;
    padding: 5px 7px;
    position: absolute;
    text-align: center;
    z-index: 999;
    content: '상담 EVENT';
    top: 0;
    left: -38%;
	  transform: translate(-50%, calc(-100% - 12px));
    font-size: 0.8rem;
    white-space: nowrap;
  }
}
</style>